const DataCollection = () => {
  return (
    <div className="mb-8">
      <h2 id="when-do-we-acquire-information" className="text-2xl font-semibold mb-4">When do we acquire information?</h2>
      <p className="mb-6">We get data from you when you get enlisted on our app or enter information on our App. Below are the examples:</p>
      <ul className="list-disc pl-6 mb-8">
        <li className="mb-2">To contact us on the App (e.g., your name and email address)</li>
        <li className="mb-2">To make purchases, all data process through Apple Store and Google Play store.</li>
        <li className="mb-2">To deal with our relationship with you, including notifying you about changes to our terms or security arrangement. Requesting that you leave an auditor to take an overview.</li>
        <li className="mb-2">To manage and ensure our business and this App (counting investigating, information examination, testing, framework upkeep, backing, revealing, and facilitating information).</li>
        <li className="mb-2">To send you our email newsletter and other automated email correspondences.</li>
        <li className="mb-2">To make proposals and recommendations to you about merchandise or administrations that might hold any importance with you.</li>
        <li className="mb-2">Voice and audio data during active voice translation sessions (processed in real-time, not stored)</li>
        <li className="mb-2">Text input for AI-assisted translation features (sent to cloud services for processing)</li>
        <li className="mb-2">Camera and image data for text extraction/OCR translation</li>
      </ul>
    </div>
  );
};

export default DataCollection;